import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "backdrop"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_4 = { class: "m-0 p-0" }

import {reactive} from "@vue/reactivity";

export default /*@__PURE__*/_defineComponent({
  __name: 'PopupWrapper',
  props: {
    title: {},
    hide: { type: Function },
    hideCloseBtn: { type: Boolean },
    popupClass: {}
  },
  emits: ['onHide'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit
const props = __props
const state = reactive({
  visible: false
});

const show = () => {
  state.visible = true;
}

const hide = () => {
  state.visible = false;
  emit('onHide')
}

const isVisible = (): boolean => {
  return state.visible;
}

__expose({ show, hide, isVisible})

return (_ctx: any,_cache: any) => {
  return (_unref(state).visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["popup", _ctx.popupClass])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.hideCloseBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (props.hide && props.hide() || hide()), ["prevent"])),
                    class: "btn btn-secondary btn-close-popup"
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      alt: "close",
                      src: "/img/close.svg"
                    }, null, -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})